(()=>{
  var r = class extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector(".slider");
      this.slideType = this.getAttribute("slide-type");
      this.navigationOrientation = this.getAttribute("navigation-orientation");
      this.slides = this.querySelectorAll("[id^='slider-item-']");
      this.navigationType = this.getAttribute("navigation-type");
      this.sliderFirstItemNode = this.querySelector("[id^='slider-item-']");
      this.autoplay = null;
      this.resizeTimer = null;

      // Espera que el DOM y las imágenes estén listos
      setTimeout(() => this.initSlider(), 100);

      // ResizeObserver con debounce para evitar llamadas múltiples
      new ResizeObserver(() => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.initSlider(), 150);
      }).observe(this.slider);
    }

    // Elimina toda la navegación existente antes de recrearla
    clearNavigation() {
      const arrows = this.querySelector(".slider__nav-arrows");
      const verticalArrows = this.querySelector(".slider__nav-vertical-arrows");
      const dots = this.querySelector(".slider__nav");
      if (arrows) arrows.remove();
      if (verticalArrows) verticalArrows.remove();
      if (dots) dots.remove();
    }

    initSlider() {
      // Verificar que el slider tenga dimensiones reales
      if (!this.slider || this.slider.clientWidth === 0) return;

      this.slides = this.querySelectorAll("[id^='slider-item-']");
      this.sliderFirstItemNode = this.querySelector("[id^='slider-item-']");

      if (!this.slides.length) return;

      this.slides[0].classList.add("slider__item--active");
      this.sliderItemsToShow = Array.from(this.slides).filter(e => e.clientWidth > 0);

      if (this.sliderItemsToShow.length === 0) return;
      this.currentPage = 0;

      // Con una sola imagen no necesitamos nada más
      if (this.sliderItemsToShow.length < 2) {
        this.clearNavigation();
        if (this.autoplay) clearInterval(this.autoplay);
        return;
      }

      // Calcular offsets
      if (this.navigationOrientation == "vertical" && window.screen.width > 1000) {
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;
        this.slidesPerPage = Math.floor(
          (this.slider.clientHeight - this.sliderItemsToShow[0].offsetTop) / this.sliderItemOffset
        );
      } else {
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        this.slidesPerPage = Math.floor(
          (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
        );
      }

      // Si el offset es 0 las imágenes aún no tienen layout — reintentar
      if (this.sliderItemOffset === 0) {
        setTimeout(() => this.initSlider(), 200);
        return;
      }

      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

      if (this.slideType == "thumbnail") {
        this.sliderItemsToShow.length <= this.slidesPerPage && (this.noRotatePages = true);
        this.createImageNavigation();
      }

      // Limpiar y recrear navegación desde cero
      this.clearNavigation();
      this.createNavigation();

      // Registrar scroll listener solo una vez
      this.slider.removeEventListener("scroll", this._scrollHandler);
      this._scrollHandler = this.navigationScroll.bind(this);
      this.slider.addEventListener("scroll", this._scrollHandler);

      // Autoplay
      if (this.getAttribute("autoplay") === "true") this.setAutoPlay();
    }

    resetPages() {
      this.slides = this.querySelectorAll('[id^="slider-item-"]');
      this.initSlider();
    }

    setAutoPlay() {
      this.sliderSpeed = this.getAttribute("speed") * 1000 || 5000;
      this.setAttribute("aria-live", "off");
      if (this.autoplay) clearInterval(this.autoplay);
      this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.sliderSpeed);
    }

    autoRotateSlides() {
      let nextLeft = this.currentPage === this.totalPages - 1
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector(".slider__item").clientWidth;
      this.slider.scrollTo({ left: nextLeft });
    }

    navigationScroll() {
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset);
      this.cleanNavigationItem();
      this.activeNavigationItem(this.currentPage);
    }

    createNavigation() {
      switch (this.navigationType) {
        case "dots":
          this.createDotsNavigation();
          this.initDotsNavigation();
          break;
        case "arrow":
          this.createArrowNavigation();
          break;
        case "both":
          this.createArrowNavigation();
          this.createDotsNavigation();
          this.initDotsNavigation();
          break;
        default:
          break;
      }
    }

    createImageNavigation() {
      this.thumbItems = this.querySelector(".product__media-tuhumbnail__list");
      if (!this.thumbItems) return;
      this.slides.forEach((e, t) => { e.children[0].setAttribute("data-slide", t); });
      this.thumbItems.removeEventListener("click", this._thumbHandler);
      this._thumbHandler = this.imageNavigationClick.bind(this);
      this.thumbItems.addEventListener("click", this._thumbHandler);
    }

    imageNavigationClick(e) {
      let t = e.target;
      let i = t.getAttribute("data-slide");
      this.currentPage = i;
      let s = document.querySelectorAll("slider-component");
      this.slides.forEach(a => { a.classList.remove("slider__item--active"); });
      t.parentNode.classList.add("slider__item--active");
      s.forEach(a => { a != this && a.moveSLides(e, i); });
    }

    createArrowNavigation() {
      if (this.slideType == "thumbnail" && this.noRotatePages != null) return;

      let nav = document.createElement("nav");
      let prev = document.createElement("button");
      let next = document.createElement("button");
      prev.innerHTML = "<span hidden>Imagen anterior</span>";
      next.innerHTML = "<span hidden>Imagen siguiente</span>";

      if (this.navigationOrientation == "vertical" && window.screen.width > 1000) {
        nav.classList.add("slider__nav-vertical-arrows");
        prev.classList.add("slider__control-vertical", "prev");
        next.classList.add("slider__control-vertical", "next");
        prev.addEventListener("click", (ev) => this.changeImage(ev, Math.round(this.slider.scrollTop / this.sliderItemOffset)));
        next.addEventListener("click", (ev) => this.changeImage(ev, Math.round(this.slider.scrollTop / this.sliderItemOffset)));
      } else {
        nav.classList.add("slider__nav-arrows");
        prev.classList.add("slider__control", "prev");
        next.classList.add("slider__control", "next");
        prev.addEventListener("click", (ev) => this.changeImage(ev, Math.round(this.slider.scrollLeft / this.sliderItemOffset)));
        next.addEventListener("click", (ev) => this.changeImage(ev, Math.round(this.slider.scrollLeft / this.sliderItemOffset)));
      }
      nav.appendChild(prev);
      nav.appendChild(next);
      this.appendChild(nav);
    }

    changeImage(e, t) {
      let { target: i } = e;
      let s = this.slides.length - 1;
      this.slides.forEach(a => { a.classList.remove("slider__item--active"); });
      i.classList.contains("prev")
        ? (t == 0 ? t = s : t = t - 1)
        : (t == s ? t = 0 : t = t + 1);
      this.slides[t].classList.add("slider__item--active");
      this.moveSLides(e, t);
    }

    createDotsNavigation() {
      let nav = document.createElement("nav");
      nav.classList.add("slider__nav");
      this.slides.forEach((t, i) => {
        let btn = document.createElement("button");
        btn.setAttribute("data-slide", i);
        btn.classList.add("slider__nav__item");
        nav.appendChild(btn);
      });
      this.appendChild(nav);
    }

    initDotsNavigation() {
      this.navigation = this.querySelector(".slider__nav");
      this.navigationItems = Array.from(this.querySelectorAll(".slider__nav__item"));
      this.navigationItems[0].setAttribute("aria-label", "Current slide");
      this.navigationItems[0].classList.add("slider__nav__item--active");
      this.navigationItems[0].setAttribute("data-active", "true");
      this.navigation.removeEventListener("click", this._dotsHandler);
      this._dotsHandler = this.handleNavigationClick.bind(this);
      this.navigation.addEventListener("click", this._dotsHandler);
    }

    cleanNavigationItem(e) {
      this.navigationItems && this.navigationItems.forEach(t => {
        if (e !== t.dataset.slide) {
          t.setAttribute("data-active", "false");
          t.setAttribute("aria-label", "Slide");
          t.classList.remove("slider__nav__item--active");
        }
      });
    }

    activeNavigationItem(e) {
      if (this.navigationItems && this.navigationItems[e]) {
        this.navigationItems[e].setAttribute("data-active", "true");
        this.navigationItems[e].setAttribute("aria-label", "Current slide");
        this.navigationItems[e].classList.add("slider__nav__item--active");
      }
    }

    handleNavigationClick(e) {
      let t = e.target;
      if (t.tagName !== "BUTTON") return;
      let i = t.getAttribute("data-slide");
      this.slides.forEach(s => { s.classList.remove("slider__item--active"); });
      this.slides[i].classList.add("slider__item--active");
      this.currentPage = i;
      this.moveSLides(e, i);
    }

    moveSLides(e, t) {
      e.preventDefault();
      if (this.navigationOrientation == "vertical" && window.screen.width > 1000) {
        let top = this.sliderFirstItemNode.clientHeight * t;
        this.slider.scrollTo({ top: top });
        if (t == this.totalPages) this.slider.scrollTo({ top: 0 });
      } else {
        let left = this.sliderFirstItemNode.clientWidth * t;
        this.slider.scrollTo({ left: left });
        if (t == this.totalPages) this.slider.scrollTo({ left: 0 });
      }
    }
  };

  customElements.define("slider-component", r);
})();